module.exports = __webpack_public_path__ + "img/project.294af91c.png";